import { Model, Attr } from "spraypaint";
import { ApplicationRecord } from "./ApplicationRecord";

@Model()
export class SurveyRoom extends ApplicationRecord {
  static jsonapiType = "survey_rooms";

  @Attr() roomName!: string;
}
